import {
  ACTIVATING_FIREFLIES_REQUEST, ACTIVATING_FIREFLIES_SUCCEDDED, ACTIVATING_FIREFLIES_FAILED,
  UPDATING_FIREFLIES_RECORDING_TOGGLE_REQUEST, UPDATING_FIREFLIES_RECORDING_TOGGLE_SUCCEEDED, UPDATING_FIREFLIES_RECORDING_TOGGLE_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  activation: {
    activating: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  },
  recordingEnabled: {
    loading: false,
    enabled: null,
    error: null,
  },
};

function fireFliesReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATING_FIREFLIES_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: true,
          error: null
        }
      });
    case ACTIVATING_FIREFLIES_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: null
        }
      });
    case ACTIVATING_FIREFLIES_FAILED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: action.payload
        }
      });

    case UPDATING_FIREFLIES_RECORDING_TOGGLE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        recordingEnabled: {
          ...state.recordingEnabled,
          loading: true,
          error: null,
        },
      });
    case UPDATING_FIREFLIES_RECORDING_TOGGLE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        recordingEnabled: {
          ...state.recordingEnabled,
          loading: false,
          enabled: action.payload.data.configuration.callRecordingEnabled,
          error: null,
        },
      });
    case UPDATING_FIREFLIES_RECORDING_TOGGLE_FAILED:
      return Object.assign({}, state, {
        ...state,
        recordingEnabled: {
          ...state.recordingEnabled,
          loading: false,
          error: action.payload,
        },
      });

    default:
      return state;
  }
}

export { fireFliesReducer };